import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Autocomplete, FormControl, TextField } from '@mui/material';

import { copyStudyBudgetWithNewClient } from '../../../../../../../actions/finance/budget/copyStudyBudgetAction';
import { FinClientApi } from '../../../../../../../api';
import Common from '../../../../../../../common/common';
import ModalBoxes from '../../../../../../../common/feedback/ModalBoxes/ModalBoxes';
import Button from '../../../../../../../common/general/Button';
import ButtonGroup from '../../../../../../../common/general/ButtonGroup';

import './CopyBudgetWithNewClientModal.scss';

export const CopyBudgetWithNewClientModal = ({ modalBox, budgetId }) => {
  const dispatch = useDispatch();
  const [selectedClient, setSelectedClient] = useState(null);
  const [clients, setClients] = useState([]);

  useEffect(() => {
    FinClientApi.findByEnabled(true).then(({ data }) => {
      setClients(data.slice().sort(Common.generateSortFuncObjectFieldAlphabetical('name')));
    });
  }, []);

  return (
    <>
      <ModalBoxes.Body>
        <div className="copy-budget-body-text">Select the client for the copied budget</div>
        <FormControl id="copy-budget-form-control" fullWidth variant="outlined">
          <Autocomplete
            id="copy-budget-client-drop-down"
            fullWidth
            options={clients}
            getOptionLabel={option => option.name}
            value={selectedClient}
            onChange={(event, newValue) => {
              setSelectedClient(newValue);
            }}
            renderInput={params => <TextField {...params} label="Client" required />}
          />
        </FormControl>
      </ModalBoxes.Body>
      <ModalBoxes.Footer>
        <ButtonGroup>
          <Button priority="low" onClick={modalBox.close}>
            Cancel
          </Button>
          <Button
            onClick={() => {
              dispatch(copyStudyBudgetWithNewClient(budgetId, selectedClient.id));
              modalBox.close();
            }}
            disabled={!selectedClient}
          >
            Confirm
          </Button>
        </ButtonGroup>
      </ModalBoxes.Footer>
    </>
  );
};
